import { Briefcase } from "lucide-react";
import { Link } from "react-router-dom";

export function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer
      role="contentinfo"
      className="relative overflow-hidden"
      style={{
        // Combine gradient + ultra-light texture in one paint layer to reduce overlays
        background:
          'linear-gradient(180deg, #FFFDF8 0%, #FFFFFF 100%), repeating-linear-gradient(45deg, rgba(0,0,0,.018) 0, rgba(0,0,0,.018) 1px, transparent 1px, transparent 6px)',
        backgroundBlendMode: 'normal',
        backgroundSize: 'auto, 8px 8px',
        contain: 'paint',
      }}
    >
      <style>{`
        .nxr-footer-link{ position:relative; color: #374151; transition: color .2s ease }
        .nxr-footer-link:after{ content:''; position:absolute; left:0; right:0; bottom:-3px; height:2px; background: currentColor; transform:scaleX(0); transform-origin:left; transition: transform .25s ease, opacity .25s ease; opacity:.0 }
        .nxr-footer-link:hover{ color:#1f2937 }
        .nxr-footer-link:hover:after{ transform:scaleX(1); opacity:.9 }
        .nxr-shimmer{ background:linear-gradient(90deg, transparent, rgba(0,0,0,.10), transparent); animation:nxr-shimmer 6s linear infinite; opacity:.10; will-change: transform }
        @keyframes nxr-shimmer{ 0%{ transform:translateX(-8%) } 50%{ transform:translateX(8%) } 100%{ transform:translateX(-8%) } }
        @media(prefers-reduced-motion:reduce){ .nxr-shimmer{ animation:none } }
      `}</style>

      {/* top divider gradient */}
      <div className="absolute left-0 right-0 top-0 h-px" style={{ background:'linear-gradient(90deg, #A3CFA2, #9B8FC1)' }} />
      {/* texture moved into background to reduce overlay paints */}

      <div className="max-w-6xl mx-auto px-6 py-14 relative z-10 text-neutral-700">
        {/* Top row */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10">
          {/* Brand block */}
          <div>
            <div className="relative flex items-center gap-3">
              <svg className="absolute -left-3 -top-2 w-10 h-10 opacity-10" viewBox="0 0 100 100" fill="none" aria-hidden>
                <path d="M50 10 C30 25, 25 45, 50 90 C 75 45, 70 25, 50 10 Z" stroke="#2d6a4f" strokeWidth="3" fill="none" />
              </svg>
              <img src="/lovable-uploads/Favicon.png" alt="Nomera Health Logo" className="w-9 h-9 rounded-xl" />
              <span className="text-xl font-bold text-neutral-900">Nomera Health</span>
            </div>
            <p className="mt-3 text-sm text-neutral-700">Hire in the most humane, and efficient way.</p>
          </div>

          {/* Navigation */}
          <div className="grid grid-cols-2 gap-6">
            <div>
              <h4 className="text-neutral-900 font-semibold mb-3">Company</h4>
              <ul className="space-y-2 text-sm">
                <li><Link to="/vision" className="nxr-footer-link">Vision</Link></li>
                <li><a href="#stories" className="nxr-footer-link">Stories</a></li>
                <li><Link to="#" className="nxr-footer-link">Contact</Link></li>
              </ul>
            </div>
            <div>
              <h4 className="text-neutral-900 font-semibold mb-3">Product</h4>
              <ul className="space-y-2 text-sm">
                <li><Link to="/auth" className="nxr-footer-link" style={{ color:'#1f6f43' }}>For Candidates</Link></li>
                <li><Link to="/auth" className="nxr-footer-link" style={{ color:'#5f5796' }}>For Employers</Link></li>
                <li><a href="#how-it-works" className="nxr-footer-link">How It Works</a></li>
              </ul>
            </div>
          </div>

          {/* Trust & Contact */}
          <div>
            <h4 className="text-neutral-900 font-semibold mb-3">Trust & Contact</h4>
            <ul className="space-y-2 text-sm">
              <li><Link to="/privacy" className="nxr-footer-link">Privacy Policy</Link></li>
              <li><Link to="#" className="nxr-footer-link">Terms of Service</Link></li>
              <li><Link to="#" className="nxr-footer-link">Contact Us</Link></li>
            </ul>
            {/* Optional mini-signup placeholder */}
            <div className="mt-4">
              <div className="flex items-center gap-2 opacity-60 pointer-events-none" aria-disabled="true">
                <input disabled aria-label="Email" placeholder="name@email.com" className="h-9 flex-1 rounded-md border border-black/10 bg-white/60 px-3 text-sm" />
                <button disabled className="h-9 px-3 rounded-md bg-gray-300 text-gray-600 text-sm">Stay in the loop</button>
              </div>
              <p className="sr-only">Signup temporarily disabled.</p>
            </div>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="relative mt-10 pt-6">
          <div className="nxr-shimmer absolute left-0 right-0 -top-2 h-px" />
          <div className="flex flex-wrap items-center gap-2 text-sm text-neutral-600">
            <span>© {year} Nomera Health</span>
            <span>•</span>
            <Link to="/privacy" className="nxr-footer-link">Privacy Policy</Link>
            <span>•</span>
            <Link to="#" className="nxr-footer-link">Terms of Service</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}